<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <h3 class="text-white">{{ 'USERS_MANAGEMENT.RESULT_FICTITIOUS_USERS_CREATION' | translate }}</h3>
  </div>
  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <div class="overflow-x-auto shadow-md rounded-lg">
      <div class="w-full overflow-x-auto">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo dark:text-white"
          (matSortChange)="sortDataChange($event)">
          <ng-container matColumnDef="organisation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{
            'USERS_MANAGEMENT.FIRST_NAME' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ element.prenom | tiret }}
            </td>
          </ng-container>
          <ng-container matColumnDef="groupe">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{
            'USERS_MANAGEMENT.LAST_NAME' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.nom |
            tiret}} </td>
          </ng-container>
          <ng-container matColumnDef="prenomNom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
            'USERS_MANAGEMENT.EMAIL' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.courriel | tiret}}
            </td>
          </ng-container>
          <ng-container matColumnDef="titre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
            'USERS_MANAGEMENT.PASSWORD' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ element.password | tiret}}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2">{{
            'USERS_MANAGEMENT.ACTIONS' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b text-center">
              <button mat-icon-button (click)="copyCredentials(element)"
                class="text-blue-600 hover:text-blue-800"
                [matTooltip]="'USERS_MANAGEMENT.COPY_CREDENTIALS' | translate">
                <mat-icon class="text-sm">content_copy</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
        @if (dataSource.filteredData.length === 0) {
          <div class="text-center mt-2 text-gray-500 dark:text-white">{{
          'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}</div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
          [length]="totalItems" [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </div>
  </div>
  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
    <button mat-button type="button" (click)="exporterIdentifiants()"
      class="mr-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-500 rounded-md hover:bg-gray-50 flex items-center gap-2">
      <mat-icon>download</mat-icon>
      <span>{{ 'USERS_MANAGEMENT.EXPORT_EXCEL' | translate }}</span>
    </button>
    <button mat-button color="primary" [mat-dialog-close]="true"
      class="mr-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-500 rounded-md hover:bg-gray-50">
      {{ 'USERS_MANAGEMENT.CLOSE' | translate }}
    </button>
  </div>
</div>
